import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 810.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,810.000000) scale(0.100000,-0.100000)">

<path d="M3965 5716 c-14 -24 -43 -84 -64 -133 -168 -387 -172 -829 -10 -1219
49 -119 99 -205 113 -196 64 40 166 114 166 121 0 4 -17 46 -39 92 -56 123
-90 229 -112 357 -46 270 -11 535 103 790 28 62 49 114 47 116 -33 24 -169
116 -173 116 -3 0 -17 -20 -31 -44z"/>
<path d="M6589 5699 l-86 -60 42 -84 c46 -92 85 -207 112 -330 13 -60 18 -126
18 -260 0 -134 -5 -200 -18 -260 -27 -124 -66 -239 -112 -331 l-43 -85 92 -64
c106 -76 94 -81 162 61 107 222 149 416 148 679 0 201 -15 304 -65 464 -36
111 -137 331 -153 331 -6 -1 -50 -28 -97 -61z"/>
<path d="M5207 5605 c-51 -12 -121 -36 -157 -54 -67 -33 -170 -106 -169 -119
0 -4 40 -35 90 -69 l89 -62 47 29 c73 46 138 64 233 64 96 0 160 -18 234 -64
l47 -30 89 62 c49 35 89 66 90 71 0 13 -124 100 -185 127 -145 66 -259 79
-408 45z"/>
<path d="M4332 5432 c-102 -220 -130 -456 -83 -688 29 -139 96 -314 122 -314
10 0 165 106 173 119 3 4 -11 46 -30 93 -51 127 -70 271 -55 410 11 101 44
226 76 288 8 16 15 31 15 34 0 5 -176 126 -183 126 -2 0 -18 -31 -35 -68z"/>
<path d="M6222 5441 c-46 -32 -85 -61 -88 -63 -2 -3 7 -31 21 -63 93 -208 92
-501 0 -704 -14 -29 -23 -57 -20 -62 3 -4 45 -35 93 -69 l87 -61 37 78 c107
225 132 494 67 745 -22 88 -89 250 -104 254 -5 2 -47 -23 -93 -55z"/>
<path d="M4721 5186 c-31 -82 -44 -180 -38 -270 6 -80 39 -210 57 -221 5 -3
50 23 100 57 88 61 90 63 83 93 -10 38 -10 202 0 237 7 25 2 31 -75 85 -46 33
-88 62 -95 66 -7 5 -18 -11 -32 -47z"/>
<path d="M5841 5174 c-85 -61 -91 -67 -84 -92 10 -35 10 -198 1 -237 -8 -29
-5 -32 82 -93 50 -35 95 -60 100 -57 5 3 20 38 32 78 33 105 33 282 -1 385
-13 40 -27 75 -31 77 -4 3 -49 -25 -99 -61z"/>
<path d="M5276 5156 c-47 -18 -104 -70 -122 -113 -19 -45 -17 -120 5 -169 10
-22 38 -56 62 -75 40 -32 48 -34 115 -34 64 0 77 3 116 30 93 66 119 185 58
276 -51 79 -152 115 -234 85z"/>
<path d="M5005 4588 c-33 -23 -75 -53 -94 -67 l-35 -25 49 -43 c51 -44 153
-99 240 -129 70 -24 248 -24 335 -1 111 29 299 138 299 172 0 6 -41 38 -90 71
l-91 62 -42 -28 c-22 -15 -61 -34 -86 -43 -68 -22 -188 -30 -245 -16 -53 13
-140 52 -165 75 -14 11 -24 8 -75 -28z"/>
<path d="M4692 3828 c-7 -7 -12 -19 -12 -28 0 -40 61 -55 80 -21 13 25 13 27
-6 45 -18 19 -45 21 -62 4z"/>
<path d="M6504 3814 c-39 -19 -64 -62 -64 -109 0 -49 44 -91 128 -123 49 -19
63 -29 68 -49 9 -32 -5 -54 -39 -66 -35 -11 -81 11 -85 41 -3 18 -10 22 -43
22 -46 0 -50 -16 -19 -68 55 -90 217 -80 256 15 31 72 1 124 -91 163 -103 44
-117 58 -96 98 22 41 111 30 111 -13 0 -11 11 -15 40 -15 46 0 49 10 20 57
-36 59 -119 80 -186 47z"/>
<path d="M3340 3610 l0 -210 40 0 40 0 0 210 0 210 -40 0 -40 0 0 -210z"/>
<path d="M3730 3663 c0 -215 9 -240 88 -258 31 -6 32 -6 32 28 0 25 -5 36 -18
40 -26 6 -32 46 -32 208 l0 139 -35 0 -35 0 0 -157z"/>
<path d="M5290 3609 l0 -212 72 7 c130 12 209 73 224 174 21 139 -76 242 -228
242 l-68 0 0 -211z m178 107 c36 -33 37 -37 37 -101 0 -64 -1 -68 -37 -101
-28 -25 -47 -34 -73 -34 l-35 0 0 135 0 135 35 0 c26 0 45 -9 73 -34z"/>
<path d="M7070 3609 l0 -212 88 5 c97 6 136 21 175 68 53 63 40 175 -27 223
-33 23 -100 30 -143 14 -22 -8 -23 -6 -23 52 l0 61 -35 0 -35 0 0 -211z m190
31 c28 -15 43 -69 29 -108 -14 -39 -53 -62 -109 -62 l-40 0 0 80 c0 65 3 81
18 89 22 13 78 14 102 1z"/>
<path d="M5973 3788 l-33 -9 0 -157 c0 -125 3 -162 15 -179 16 -23 70 -43 118
-43 24 0 27 3 27 35 0 33 -2 35 -33 35 -49 0 -57 14 -57 102 l0 78 45 0 c43 0
45 1 45 30 0 29 -2 30 -44 30 l-45 0 -3 43 -3 43 -32 -8z"/>
<path d="M3952 3703 c-28 -13 -62 -57 -62 -78 0 -14 62 -3 80 15 37 37 100 19
100 -29 0 -27 0 -28 -55 -23 -68 6 -111 -11 -131 -50 -34 -66 20 -138 105
-138 26 0 56 7 69 16 20 14 22 14 22 0 0 -11 10 -16 30 -16 l30 0 0 118 c0
133 -9 159 -60 184 -43 22 -85 22 -128 1z m96 -169 c27 -19 29 -60 3 -74 -49
-26 -118 3 -109 47 3 18 42 43 68 43 9 0 26 -7 38 -16z"/>
<path d="M4286 3699 c-21 -17 -26 -18 -26 -5 0 11 -9 16 -30 16 l-30 0 0 -155
0 -155 35 0 35 0 0 106 c0 121 8 144 50 144 52 0 60 -19 60 -141 l0 -109 35 0
35 0 0 103 c0 118 12 147 60 147 42 0 50 -23 50 -144 l0 -106 35 0 35 0 0 125
c0 122 -1 125 -27 155 -38 42 -90 50 -138 21 l-37 -21 -25 20 c-33 26 -83 26
-117 -1z"/>
<path d="M4915 3713 c-35 -9 -87 -54 -101 -89 -32 -76 -7 -152 65 -201 67 -45
173 -23 218 46 31 47 29 61 -8 61 -22 0 -37 -8 -51 -26 -59 -74 -168 -35 -168
60 0 14 13 40 29 58 39 44 93 44 133 -1 19 -22 37 -31 58 -31 35 0 38 13 10
58 -33 53 -115 82 -185 65z"/>
<path d="M5705 3711 c-24 -10 -60 -49 -68 -73 -10 -28 64 -25 81 2 28 46 102
11 102 -48 0 -18 -3 -21 -17 -13 -44 23 -115 16 -152 -15 -40 -33 -43 -89 -8
-129 26 -31 97 -44 146 -27 19 7 31 7 31 1 0 -5 16 -9 36 -9 l36 0 -4 125 -3
125 -32 31 c-25 25 -41 32 -80 35 -26 2 -57 0 -68 -5z m103 -188 c16 -23 15
-30 -8 -53 -36 -36 -110 -20 -110 25 0 51 85 71 118 28z"/>
<path d="M6204 3706 c-32 -14 -64 -51 -64 -73 0 -21 58 -15 80 7 37 37 100 17
100 -33 0 -21 -5 -22 -74 -22 -58 0 -78 -4 -94 -19 -45 -40 -36 -117 17 -149
36 -21 109 -22 139 -1 20 14 22 14 22 0 0 -11 10 -16 30 -16 l30 0 0 123 c0
137 -8 159 -66 183 -41 17 -80 17 -120 0z m103 -178 c30 -25 -1 -78 -46 -78
-38 0 -73 27 -69 53 6 41 77 56 115 25z"/>
<path d="M3495 3685 c-31 -30 -34 -86 -6 -114 10 -10 44 -26 75 -35 60 -18 77
-36 56 -61 -9 -11 -33 -15 -81 -15 l-69 0 0 -30 c0 -30 0 -30 59 -30 118 0
171 29 171 93 0 49 -26 75 -95 95 -41 13 -61 24 -63 36 -6 27 15 36 81 36 54
0 57 1 57 25 0 25 -1 25 -80 25 -73 0 -83 -3 -105 -25z"/>
<path d="M4690 3555 l0 -155 35 0 35 0 0 155 0 155 -35 0 -35 0 0 -155z"/>
<path d="M6750 3618 c0 -163 27 -209 128 -216 51 -4 62 -1 90 23 40 34 52 77
52 193 l0 92 -40 0 -40 0 0 -110 c0 -107 -1 -110 -26 -127 -24 -15 -29 -15
-53 -2 -25 14 -26 17 -29 127 l-3 112 -39 0 -40 0 0 -92z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
